import { TextTestID } from "@/constants/TestID";
import type { ButtonVariant } from "@/ui/core/buttons/Button";
import Button from "@/ui/core/buttons/Button";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import BaseCard from "@/ui/layout/BaseCard";
import EmptyListContent from "@/ui/layout/list/EmptyListContent";
import { VStack } from "@/ui/layout/Stacks";
import type { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";
import { getIllustrationIcon } from "@/ui/theme/icons/illustrations/groupClasses";
import { joinTestIDs } from "@/utils/string.util";

interface EmptyListBaseCardProps {
  buttonRightIcon?: FAIconName;
  buttonTitle?: string;
  buttonVariant?: ButtonVariant;
  description: string;
  iconHeight: SizeDimension;
  iconName: IllustrationName;
  iconWidth: SizeDimension;
  isCentered?: boolean;
  maxHeight?: number;
  onButtonPress?: () => Promise<void> | void;
  testID: string;
  title: string;
}

const EmptyListBaseCard = ({
  buttonRightIcon = FAIconName.ChevronRight,
  buttonTitle,
  buttonVariant = "tertiary",
  description,
  iconHeight,
  iconName,
  iconWidth,
  isCentered,
  maxHeight,
  onButtonPress,
  testID,
  title,
}: EmptyListBaseCardProps) => {
  const IllustrationIcon = getIllustrationIcon({
    height: iconHeight,
    iconName,
    width: iconWidth,
  });

  return (
    <BaseCard
      isBorderDashed
      maxHeight={maxHeight}
      testID={joinTestIDs(testID, TextTestID.Card)}
    >
      <VStack alignItems={isCentered ? "center" : "flex-start"} gap={8}>
        {IllustrationIcon}
        <EmptyListContent
          isCentered={isCentered}
          paragraphs={[description]}
          testID={testID}
          title={title}
        />
        {buttonTitle && onButtonPress && (
          <Button
            onPress={onButtonPress}
            rightIcon={buttonRightIcon}
            testID={joinTestIDs(testID, "button")}
            title={buttonTitle}
            variant={buttonVariant}
          />
        )}
      </VStack>
    </BaseCard>
  );
};

export type { EmptyListBaseCardProps };
export default EmptyListBaseCard;
